import { IntensityTraffic } from 'store/wim/types/transits';

export const parseIntensityTrafficData = (data: IntensityTraffic[]) =>
  data.map((item) => ({
    ...item,
    totalViolations: item.overaxleload + item.overdimension + item.overgroupload + item.overload,
  }));
